<template>
  <div>
    <div :class="isChain?'chain_RelatedReport':''">
      <h2 class="chain_title1" v-if="isChain">全国{{ title }}拿地项目</h2>
      <el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
				<freeUserTips :type="4" :bgtype="0" :isShowDownFile="true"></freeUserTips>
			</el-dialog>
      <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
        <tr>
          <th>排名</th>
          <th>行政区</th>
          <th>项目名称</th>
          <th>总面积(亩)</th>
          <th>土地用途</th>
          <th style="line-height: 20px; padding: 10px 0">
            土地使用权人<br />(项目公司)
          </th>
          <th>投资主体</th>
          <th>投资来源地</th>
          <th>日期</th>
        </tr>
        <tr :key="index" v-for="(list, index) in landList">
          <td>{{ index + 1 }}</td>
          <td>{{ list.area }}</td>
          <td style="width: 120px">
            <span :class="list.url && list.url != '' ? 'curp' : ''" @click="openProjectLink(list.url)">{{
              list.projectName }}</span>
          </td>
          <!-- <td style="width: 120px;">{{list.projectName}}</td> -->
          <td>{{ list.size }}{{ list.sizeUnit }}</td>
          <td>{{ list.purpose }}</td>
          <td style="width: 110px">
            <span class="curp" v-if="list.stockCode != ''" @click="routerlinkid('/enterprises', list.stockCode)">{{
              list.owner }}</span>
            <span v-if="list.stockCode == ''">{{ list.owner }}</span>
          </td>
          <td style="width: 110px">
            <span class="curp" v-if="list.sourceStockCode != ''"
              @click="routerlinkid('/enterprises', list.sourceStockCode)">{{ list.sourceEnterprise }}</span>
            <span v-if="list.sourceStockCode == ''">{{
              list.sourceEnterprise
              }}</span>
          </td>
          <td>{{ list.sourceArea }}</td>
          <td>{{ list.time }}</td>
        </tr>
      </table>
      <p v-if="isChain" class="text-center my-2 curp widthPC-100 font-18" @click="openUrl('land')">更多拿地项目 ></p>

    </div>
  </div>
</template>
<script>
import { sortKey } from '@/utils/index'
export default {
  data() {
    return {
      isShowFreeUserTips: false,
      userdata: {},
    }
  },
  props: {
    userdata: {},
    landList: { type: Array, default: [] },
    title: { type: String, default: '' },
    isChain:{type:Boolean,default:true},//产业链详情和竞争格局、市场规模都用到了这个组件
  },
  mounted() {
    this.userdata = this.getuseriformation();
    sortKey(this.landList,'time',1);
  },
  methods: {
    openProjectLink(url) {
      if (url && url != '') {
        window.open(url); //研究报告库外部跳转
      }
    },
    openUrl(url) { //外部跳转拿地信息库 投资项目库跳转
      if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				return;
			}
			if (url == "land" || url == 'invest') {
				this.$axios.get(this.$api.enterpriseapi.land.url(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function (res) {
					window.open(res.data.data[url]);
					// that.listUrl=res.data.data.invest; 
				})
			}
		}
  }
}
</script>
